//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
} from "../../../helpers/fakebackend_helper";

import { postREJwtLogin, getSignIn } from "../../../helpers/realbackend_helper";
import axios from "axios";
import { setAuthorization } from "../../../helpers/api_helper";
import { resetAppState } from "../../resetAction";
import { getCampaignsWithCounts } from "../../campaign/thunk";

import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from './reducer';

const fireBaseBackend = getFirebaseBackend();

export const loginUser = (user, history) => async (dispatch) => {
  
  try {
    let response;
    response = await getSignIn({
      email: user.email,
      password: user.password
    });

    var data = await response;
  
    if (data) {
      localStorage.setItem("authUser", JSON.stringify(data));
      if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
        var finallogin = JSON.stringify(data);
        finallogin = JSON.parse(finallogin)
        data = finallogin.data;
        if (finallogin.status === "success") {
          dispatch(loginSuccess(data));
          history('/dashboard');
        } else {
          dispatch(apiError(finallogin));
        }
      } else {
        // INJECT TOKEN TO GLOBAL AXIOS INSTANCE DIRECTLY!
        if (data.accessToken) {
          setAuthorization(data.accessToken);
        }
        // Өмнөх хэрэглэгчийн судалгаа/нийтлэл санах ойд үлдэхээс сэргийлнэ
        dispatch(resetAppState());
        dispatch(loginSuccess(data));
        // Pre-load sidebar campaigns immediately after login (non-SuperAdmin only)
        if (data?.role !== "SuperAdmin") {
          dispatch(getCampaignsWithCounts());
        }
        history("/");
      }
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    localStorage.removeItem("authUser");
    // Токен ба бүх өгөгдлийг цэвэрлэнэ — дараагийн хэрэглэгч өмнөхийнхийг харахгүй
    delete axios.defaults.headers.common["token"];
    dispatch(resetAppState());
    dispatch(logoutUserSuccess(true));
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};